import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileZip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFileZip"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2H4V22H8V20H10V22H20V10H12V2ZM10 18H12V20H10V18ZM10 16H8V18H10V16ZM10 14V16H12V14H10ZM10 14V12H8V14H10Z" fill="currentColor"/><Path d="M14 2.08579V8H19.9142L14 2.08579Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFileZip;
